import { registerPlugin } from '@capacitor/core';

export interface ScreenProtectionPlugin {
  enable(): Promise<{ enabled: boolean }>;
  disable(): Promise<{ enabled: boolean }>;
}

const ScreenProtection = registerPlugin<ScreenProtectionPlugin>('ScreenProtection', {
  web: () => import('./ScreenProtectionWeb').then(m => new m.ScreenProtectionWeb()),
});

export default ScreenProtection;
